import { render, staticRenderFns } from "./EditStep3.vue?vue&type=template&id=80e5feea"
import script from "./EditStep3.vue?vue&type=script&lang=js"
export * from "./EditStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports